import { render, staticRenderFns } from "./Arena.vue?vue&type=template&id=896f0282&"
import script from "./Arena.vue?vue&type=script&lang=js&"
export * from "./Arena.vue?vue&type=script&lang=js&"
import style0 from "./Arena.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports